<template>
  <div v-if="visible" class="save_dialog">
    <div class="save_dialog_content">
      <img
        class="save_dialog_content_header"
        src="~@/assets/images/common/head.png"
        alt=""
      />
      <img
        src="~@/assets/images/common/close.png"
        alt=""
        class="save_dialog_content_close"
        @click="cancel"
      />
      <div class="save_dialog_content_body">
        <h3>温馨提示</h3>
        <p>
          试卷中含有主观题，升级题库会员<br />
          可享受主观题AI判分或自助判分，<br />
          快去升级题库会员吧~
        </p>
        <div class="check-mod">
          <div class="check-mod-left">
            <h5 class="check-mod-title">放弃主观题判分</h5>
            <p class="check-mod-content">直接交卷</p>
            <a
              href="javascript:void(0);"
              class="check-mod-action"
              @click="confirm(0)"
              >直接交卷</a
            >
          </div>
          <div class="check-mod-right">
            <h5 class="check-mod-title">解锁题库会员</h5>
            <p class="check-mod-content" v-html="content"></p>
            <a
              href="javascript:void(0);"
              class="check-mod-action"
              @click="confirm(1)"
              >购买题库会员</a
            >
          </div>
        </div>
      </div>
    </div>
    <div class="save_dialog_mask"></div>
  </div>
</template>

<script>
export default {
  name: 'SavePaperDialog',
  props: {
    content: {
      type: String,
      default: '额外尊享<br />20+权益'
    }
  },
  data() {
    return {
      visible: false
    }
  },
  methods: {
    confirm(val) {
      this.$emit('done', val)
    },
    cancel() {
      this.$emit('cancel')
    }
  }
}
</script>

<style lang="scss" scoped>
.save_dialog {
  position: fixed;
  z-index: 1000;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;

  &_content {
    padding-bottom: 14px;
    width: 300px;
    min-height: 200px;
    background: #fff;
    border-radius: 24px;
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    z-index: 10;

    &_header {
      width: 300px;
      height: 149px;
      position: absolute;
      top: -39px;
      z-index: -1;
    }

    &_close {
      width: 16px;
      height: 16px;
      cursor: pointer;
      position: absolute;
      right: 17px;
      top: 12px;
    }

    &_body {
      padding-top: 72px;
      width: 100%;
      height: 100%;

      h3 {
        font-weight: bold;
        font-size: 18px;
        color: #222;
        text-align: center;
      }

      p {
        padding: 5px 10px;
        text-align: center;
        color: #666;
        line-height: 19px;
        font-size: 14px;
      }

      .check-mod {
        display: flex;
        position: relative;

        &::after {
          display: inline-block;
          content: '';
          width: 26px;
          height: 26px;
          background: url(~@/assets/images/common/save_bg_up.png) no-repeat center;
          background-size: 26px 26px;
          position: absolute;
          top: 72px;
          left: 117px;
        }

        &-left {
          margin-left: 12px;
          width: 119px;
          height: 169px;
          background: url(~@/assets/images/common/save_bg_l.png) no-repeat center;
          background-size: 119px 169px;
          display: flex;
          flex-direction: column;
          align-items: center;

          .check-mod-title {
            margin-top: 18px;
            font-weight: bold;
            font-size: 14px;
            color: #222;
            line-height: 23px;
            text-align: center;
          }

          .check-mod-content {
            flex: 1;
            padding-top: 6px;
            font-size: 14px;
            color: #222222;
            line-height: 23px;
            text-align: center;
          }

          .check-mod-action {
            margin-bottom: 15px;
            display: inline-block;
            width: 92px;
            height: 34px;
            background: transparent;
            border-radius: 17px;
            border: 1px solid #07bdc7;
            text-align: center;
            color: #07bdc7;
            font-size: 14px;
            line-height: 34px;
            cursor: pointer;
          }
        }

        &-right {
          width: 158px;
          height: 169px;
          background: url(~@/assets/images/common/save_bg_r.png) no-repeat center;
          background-size: 158px 169px;
          display: flex;
          flex-direction: column;
          align-items: center;

          .check-mod-title {
            margin-top: 18px;
            font-weight: bold;
            font-size: 14px;
            color: #222;
            line-height: 23px;
            text-align: center;
          }

          .check-mod-content {
            flex: 1;
            padding-top: 6px;
            font-size: 14px;
            color: #222222;
            line-height: 23px;
            text-align: center;
          }

          .check-mod-action {
            margin-bottom: 15px;
            display: inline-block;
            padding-left: 35px;
            width: 144px;
            height: 40px;
            background: url(~@/assets/images/common/bg_btn_vip.png) no-repeat
              center;
            background-size: 144px 40px;
            font-weight: bold;
            font-size: 16px;
            color: #ffffff;
            line-height: 40px;
            cursor: pointer;
            position: relative;

            &::before {
              display: inline-block;
              content: '';
              width: 18px;
              height: 15px;
              background: url(~@/assets/images/common/icon_vip_logo.png) no-repeat
                center;
              background-size: 18px 15px;
              position: absolute;
              top: 13px;
              left: 13px;
            }
          }
        }
      }
    }
  }

  &_mask {
    position: absolute;
    left: 0;
    top: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.6);
    z-index: 1;
  }
}
</style>
